<template>
  <v-dialog v-model="dialog" max-width="420" persistent>
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-icon>
          <v-icon>mdi-abacus</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Sammanställning av röstlängd</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title class="color-a">Sammanställning av röstlängd</v-card-title>
      <v-card-text>
        <div class="overflow-y-auto overflow-x-hidden mb-8">
          <v-simple-table light>
            <tbody>
              <tr>
                <td>{{ totalNumberOfBallots }}</td>
                <td style="width:100%">Rösträtter</td>
              </tr>
              <tr>
                <td>{{ totalNumberOfPresentBallots }}</td>
                <td>
                  Närvarande rösträtter (inkl. fullmakter)<br />
                  <template v-if="!meetingOpened"
                    >(Beräknas när mötet öppnats)</template
                  >
                </td>
              </tr>
              <tr>
                <td>{{ totalNumberOfPresentMandatedBallots }}</td>
                <td>
                  Fullmakter<br />
                  <template v-if="!meetingOpened"
                    >(Beräknas när mötet öppnats)</template
                  >
                </td>
              </tr>
              <tr>
                <td>{{ totalNumberOfMembers }}</td>
                <td>Medlemmar</td>
              </tr>
              <tr>
                <td>{{ totalNumberOfPresentMembers }}</td>
                <td>
                  Närvarande medlemmar<br />
                  <template v-if="!meetingOpened"
                    >(Beräknas när mötet öppnats)</template
                  >
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Stäng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    meeting: Object
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    // meeting() {
    //   return this.$store.getters["meetings/getMeeting"](
    //       this.$route.params.meetingId
    //   );
    // },
    meetingOpened() {
      return !!this.meeting.adminOpened;
    },
    totalNumberOfBallots() {
      const ballots = this.meeting.ballots;

      let summedShares = 0;
      for (const ballot in ballots) {
        let shares = ballots[ballot].shares;
        let share = shares == null || typeof shares == "undefined" ? 1 : shares;
        summedShares = summedShares + share;
      }
      return summedShares;
    },

    totalNumberOfMembers() {
      const ballots = this.meeting.ballots;
      const members = Object.values(ballots);
      let individuals = [];

      members.forEach(ballotIndividuals => {
        individuals = individuals.concat(ballotIndividuals.ssn);
      });
      return individuals.length;
    },

    totalNumberOfPresentMembers() {
      const electors = this.$store.getters["meetings/getElectors"];
      if (this.meeting.adminOpened) {
        return electors.length;
      } else {
        return "-";
      }
    },

    totalNumberOfPresentBallots() {
      const electors = this.$store.getters["meetings/getElectors"];
      const ballots = this.meeting.ballots;
      const presentShares = {};

      electors.forEach(elector => {
        elector.ballots.forEach(ballot => {
          let shares = ballots[ballot].shares;
          presentShares[ballot] =
            shares == null || typeof shares == "undefined" ? 1 : shares;
        });
      });

      var summedShares = 0;
      Object.keys(presentShares).forEach(
        ballot => (summedShares += presentShares[ballot])
      );
      if (this.meeting.adminOpened) {
        return summedShares;
      } else {
        return "-";
      }
    },
    totalNumberOfPresentMandatedBallots() {
      const electors = this.$store.getters["meetings/getElectors"];
      var ballotsList = {};

      electors.forEach(elector => {
        elector.delegated.forEach(delegation => {
          delegation.ballots.forEach(ballot => {
            ballotsList[ballot] = true;
          });
        });
      });
      if (this.meeting.adminOpened) {
        return Object.keys(ballotsList).length;
      } else {
        return "-";
      }
    }
  },
  methods: {
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style></style>
